import { Injectable, ɵɵdefineInjectable, ɵɵinject, NgModule } from '@angular/core';
import { HttpParams, HttpHeaders, HttpRequest, HttpResponse, HttpClient, HttpClientModule } from '@angular/common/http';
import { filter, map } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/archive-statuses.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
import * as ɵngcc0 from '@angular/core';
var ArchiveStatuses;
(function (ArchiveStatuses) {
    ArchiveStatuses.NONE = 'None';
    ArchiveStatuses.ARCHIVED = 'Archived';
    ArchiveStatuses.UNARCHIVING = 'Unarchiving';
    /**
     * @return {?}
     */
    function values() {
        return [
            ArchiveStatuses.NONE,
            ArchiveStatuses.ARCHIVED,
            ArchiveStatuses.UNARCHIVING
        ];
    }
    ArchiveStatuses.values = values;
})(ArchiveStatuses || (ArchiveStatuses = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/storage-tier.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var StorageTier;
(function (StorageTier) {
    StorageTier.NONE = 'None';
    StorageTier.STANDARD = 'Standard';
    StorageTier.ARCHIVE = 'Archive';
    StorageTier.DEEP_ARCHIVE = 'DeepArchive';
    /**
     * @return {?}
     */
    function values() {
        return [
            StorageTier.NONE,
            StorageTier.STANDARD,
            StorageTier.ARCHIVE,
            StorageTier.DEEP_ARCHIVE
        ];
    }
    StorageTier.values = values;
})(StorageTier || (StorageTier = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/file-archive-storage-tier.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileArchiveStorageTier;
(function (FileArchiveStorageTier) {
    FileArchiveStorageTier.ARCHIVE = 'Archive';
    FileArchiveStorageTier.DEEP_ARCHIVE = 'DeepArchive';
    /**
     * @return {?}
     */
    function values() {
        return [
            FileArchiveStorageTier.ARCHIVE,
            FileArchiveStorageTier.DEEP_ARCHIVE
        ];
    }
    FileArchiveStorageTier.values = values;
})(FileArchiveStorageTier || (FileArchiveStorageTier = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/job-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
var JobStatus;
(function (JobStatus) {
    JobStatus.NONE = 'None';
    JobStatus.ARCHIVING = 'Archiving';
    JobStatus.UNARCHIVING = 'Unarchiving';
    JobStatus.DELETING = 'Deleting';
    /**
     * @return {?}
     */
    function values() {
        return [
            JobStatus.NONE,
            JobStatus.ARCHIVING,
            JobStatus.UNARCHIVING,
            JobStatus.DELETING
        ];
    }
    JobStatus.values = values;
})(JobStatus || (JobStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/folder-archive-storage-tier.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FolderArchiveStorageTier;
(function (FolderArchiveStorageTier) {
    FolderArchiveStorageTier.ARCHIVE = 'Archive';
    FolderArchiveStorageTier.DEEP_ARCHIVE = 'DeepArchive';
    /**
     * @return {?}
     */
    function values() {
        return [
            FolderArchiveStorageTier.ARCHIVE,
            FolderArchiveStorageTier.DEEP_ARCHIVE
        ];
    }
    FolderArchiveStorageTier.values = values;
})(FolderArchiveStorageTier || (FolderArchiveStorageTier = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models/session-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SessionStatus;
(function (SessionStatus) {
    SessionStatus.OPEN = 'Open';
    SessionStatus.CLOSED = 'Closed';
    SessionStatus.COMPLETED = 'Completed';
    /**
     * @return {?}
     */
    function values() {
        return [
            SessionStatus.OPEN,
            SessionStatus.CLOSED,
            SessionStatus.COMPLETED
        ];
    }
    SessionStatus.values = values;
})(SessionStatus || (SessionStatus = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/models.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: api/base-service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Custom parameter codec to correctly handle the plus sign in parameter
 * values. See https://github.com/angular/angular/issues/18261
 */
class ParameterCodec {
    /**
     * @param {?} key
     * @return {?}
     */
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    encodeValue(value) {
        return encodeURIComponent(value);
    }
    /**
     * @param {?} key
     * @return {?}
     */
    decodeKey(key) {
        return decodeURIComponent(key);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    decodeValue(value) {
        return decodeURIComponent(value);
    }
}
/** @type {?} */
const PARAMETER_CODEC = new ParameterCodec();
/**
 * Base class for API services
 */
class BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        this.config = config;
        this.http = http;
        this._rootUrl = '';
    }
    /**
     * Returns the root url for API operations. If not set directly in this
     * service, will fallback to ApiConfiguration.rootUrl.
     * @return {?}
     */
    get rootUrl() {
        return this._rootUrl || this.config.rootUrl;
    }
    /**
     * Sets the root URL for API operations in this service.
     * @param {?} rootUrl
     * @return {?}
     */
    set rootUrl(rootUrl) {
        this._rootUrl = rootUrl;
    }
    /**
     * Creates a new `HttpParams` with the correct codec
     * @protected
     * @return {?}
     */
    newParams() {
        return new HttpParams({
            encoder: PARAMETER_CODEC
        });
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    BaseService.prototype._rootUrl;
    /**
     * @type {?}
     * @protected
     */
    BaseService.prototype.config;
    /**
     * @type {?}
     * @protected
     */
    BaseService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: api/gds-api-configuration.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Global configuration for GdsApi services
 */
class GdsApiConfiguration {
    constructor() {
        this.rootUrl = 'https://stage.stratus.illumina.com';
    }
}
GdsApiConfiguration.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: GdsApiConfiguration, factory: function GdsApiConfiguration_Factory(t) { return new (t || GdsApiConfiguration)(); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(GdsApiConfiguration, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, { constructor: [], rootUrl: [] });
/** @nocollapse */ GdsApiConfiguration.ngInjectableDef = ɵɵdefineInjectable({ factory: function GdsApiConfiguration_Factory() { return new GdsApiConfiguration(); }, token: GdsApiConfiguration, providedIn: "root" });
if (false) {
    /** @type {?} */
    GdsApiConfiguration.prototype.rootUrl;
}
/**
 * @record
 */
function GdsApiConfigurationInterface() { }
if (false) {
    /** @type {?|undefined} */
    GdsApiConfigurationInterface.prototype.rootUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/files.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FilesService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get information and details for the specified file ID, including metadata and a pre-signed URL for file download. The URL can be used as a curl command or directly with S3.
     * @param {?} params The `FilesService.GetFileParams` containing the following parameters:
     *
     * - `fileId`: Unique identifier for the file to retrieve.
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * @return {?} Success.
     */
    getFileResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.tenantId != null)
            __params = __params.set('tenantId', params.tenantId.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/files/${params.fileId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get information and details for the specified file ID, including metadata and a pre-signed URL for file download. The URL can be used as a curl command or directly with S3.
     * @param {?} params The `FilesService.GetFileParams` containing the following parameters:
     *
     * - `fileId`: Unique identifier for the file to retrieve.
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * @return {?} Success.
     */
    getFile(params) {
        return this.getFileResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update a file entry in GDS. Returns temporary credentials for file upload directly to S3 when the include=objectStoreAccess parameter is used. Note that the currently supported changes to the file resource are updating the file type and the underlying content.
     * @param {?} params The `FilesService.UpdateFileParams` containing the following parameters:
     *
     * - `fileId`: Unique identifier for the file to be updated.
     *
     * - `include`: Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
     *
     * - `body`:
     *
     * @return {?} Success.
     */
    updateFileResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.include != null)
            __params = __params.set('include', params.include.toString());
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/files/${params.fileId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update a file entry in GDS. Returns temporary credentials for file upload directly to S3 when the include=objectStoreAccess parameter is used. Note that the currently supported changes to the file resource are updating the file type and the underlying content.
     * @param {?} params The `FilesService.UpdateFileParams` containing the following parameters:
     *
     * - `fileId`: Unique identifier for the file to be updated.
     *
     * - `include`: Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
     *
     * - `body`:
     *
     * @return {?} Success.
     */
    updateFile(params) {
        return this.updateFileResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Permanently delete a file entry and its underlying content
     * @param {?} fileId Unique identifier for the file to delete.
     * @return {?}
     */
    deleteFileResponse(fileId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/files/${fileId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Permanently delete a file entry and its underlying content
     * @param {?} fileId Unique identifier for the file to delete.
     * @return {?}
     */
    deleteFile(fileId) {
        return this.deleteFileResponse(fileId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a file entry in GDS. Returns temporary credentials for file upload directly to S3 when the include=objectStoreAccess parameter is used. Volume ID or volume name is required for file creation. If a folder path is provided and does not exist, GDS creates the folder path in the appropriate account automatically.
     * @param {?} params The `FilesService.CreateFileParams` containing the following parameters:
     *
     * - `body`:
     *
     * - `include`: Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
     *
     * @return {?} Created new File.
     */
    createFileResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        if (params.include != null)
            __params = __params.set('include', params.include.toString());
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/files`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a file entry in GDS. Returns temporary credentials for file upload directly to S3 when the include=objectStoreAccess parameter is used. Volume ID or volume name is required for file creation. If a folder path is provided and does not exist, GDS creates the folder path in the appropriate account automatically.
     * @param {?} params The `FilesService.CreateFileParams` containing the following parameters:
     *
     * - `body`:
     *
     * - `include`: Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
     *
     * @return {?} Created new File.
     */
    createFile(params) {
        return this.createFileResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Given a volumeId or volume name, get a list of files accessible by the JWT. The default sort returned is alphabetical, ascending. The default page size is 10 items
     * @param {?} params The `FilesService.ListFilesParams` containing the following parameters:
     *
     * - `volume.name`: Optional field that specifies comma-separated volume names to include in the list
     *
     * - `volume.id`: Optional field that specifies comma-separated volume IDs to include in the list
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * - `recursive`: Optional field to specify if files should be returned recursively in and under the specified paths, or only directly in the specified paths
     *
     * - `path`: Optional field that specifies comma-separated paths to include in the list. Value can use wildcards (e.g. /a/b/c/*) or exact matches (e.g. /a/b/c/d/).
     *
     * - `pageToken`: START_DESC END_DESC
     *
     * - `pageSize`: START_DESC END_DESC
     *
     * - `isUploaded`: Optional field to filter by Uploaded files
     *
     * - `include`: START_DESC END_DESC
     *
     * - `archiveStatus`: Optional field that specifies comma-separated Archive Statuses to include in the list
     *
     * @return {?} Success.
     */
    listFilesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.volumeName || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('volume.name', val.toString()); }));
        (params.volumeId || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('volume.id', val.toString()); }));
        if (params.tenantId != null)
            __params = __params.set('tenantId', params.tenantId.toString());
        if (params.recursive != null)
            __params = __params.set('recursive', params.recursive.toString());
        (params.path || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('path', val.toString()); }));
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.isUploaded != null)
            __params = __params.set('isUploaded', params.isUploaded.toString());
        if (params.include != null)
            __params = __params.set('include', params.include.toString());
        if (params.archiveStatus != null)
            __params = __params.set('archiveStatus', params.archiveStatus.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/files`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a volumeId or volume name, get a list of files accessible by the JWT. The default sort returned is alphabetical, ascending. The default page size is 10 items
     * @param {?} params The `FilesService.ListFilesParams` containing the following parameters:
     *
     * - `volume.name`: Optional field that specifies comma-separated volume names to include in the list
     *
     * - `volume.id`: Optional field that specifies comma-separated volume IDs to include in the list
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * - `recursive`: Optional field to specify if files should be returned recursively in and under the specified paths, or only directly in the specified paths
     *
     * - `path`: Optional field that specifies comma-separated paths to include in the list. Value can use wildcards (e.g. /a/b/c/*) or exact matches (e.g. /a/b/c/d/).
     *
     * - `pageToken`: START_DESC END_DESC
     *
     * - `pageSize`: START_DESC END_DESC
     *
     * - `isUploaded`: Optional field to filter by Uploaded files
     *
     * - `include`: START_DESC END_DESC
     *
     * - `archiveStatus`: Optional field that specifies comma-separated Archive Statuses to include in the list
     *
     * @return {?} Success.
     */
    listFiles(params) {
        return this.listFilesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * This endpoint will be deprecated with the EarlyAccess launch. Utilize DELETE: v1/files/{fileId} instead.
     * @param {?} fileId Unique identifier for the file to delete.
     * @return {?}
     */
    destroyFileDeprecatedResponse(fileId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/files/${fileId}:destroy`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * This endpoint will be deprecated with the EarlyAccess launch. Utilize DELETE: v1/files/{fileId} instead.
     * @param {?} fileId Unique identifier for the file to delete.
     * @return {?}
     */
    destroyFileDeprecated(fileId) {
        return this.destroyFileDeprecatedResponse(fileId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Archives a file to a lower storage cost tier.
     * @param {?} params The `FilesService.ArchiveFileParams` containing the following parameters:
     *
     * - `fileId`: Unique identifier for the file to be archived.
     *
     * - `body`:
     *
     * @return {?} Success.
     */
    archiveFileResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/files/${params.fileId}:archive`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Archives a file to a lower storage cost tier.
     * @param {?} params The `FilesService.ArchiveFileParams` containing the following parameters:
     *
     * - `fileId`: Unique identifier for the file to be archived.
     *
     * - `body`:
     *
     * @return {?} Success.
     */
    archiveFile(params) {
        return this.archiveFileResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Unarchive a file from a lower storage cost tier.
     * @param {?} params The `FilesService.UnarchiveFileParams` containing the following parameters:
     *
     * - `fileId`: Unique identifier for the file to be unarchived.
     *
     * - `body`:
     *
     * @return {?} Accepted.
     */
    unarchiveFileResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/files/${params.fileId}:unarchive`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Unarchive a file from a lower storage cost tier.
     * @param {?} params The `FilesService.UnarchiveFileParams` containing the following parameters:
     *
     * - `fileId`: Unique identifier for the file to be unarchived.
     *
     * - `body`:
     *
     * @return {?} Accepted.
     */
    unarchiveFile(params) {
        return this.unarchiveFileResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
FilesService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: FilesService, factory: function FilesService_Factory(t) { return new (t || FilesService)(ɵngcc0.ɵɵinject(GdsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(FilesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GdsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], getFileResponse: [], getFile: [], updateFileResponse: [], updateFile: [], deleteFileResponse: [], deleteFile: [], createFileResponse: [], createFile: [], listFilesResponse: [], listFiles: [], destroyFileDeprecatedResponse: [], destroyFileDeprecated: [], archiveFileResponse: [], archiveFile: [], unarchiveFileResponse: [], unarchiveFile: [] });
FilesService.getFilePath = '/v1/files/{fileId}';
FilesService.updateFilePath = '/v1/files/{fileId}';
FilesService.deleteFilePath = '/v1/files/{fileId}';
FilesService.createFilePath = '/v1/files';
FilesService.listFilesPath = '/v1/files';
FilesService.destroyFileDeprecatedPath = '/v1/files/{fileId}:destroy';
FilesService.archiveFilePath = '/v1/files/{fileId}:archive';
FilesService.unarchiveFilePath = '/v1/files/{fileId}:unarchive';
/** @nocollapse */
FilesService.ctorParameters = () => [
    { type: GdsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ FilesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FilesService_Factory() { return new FilesService(ɵɵinject(GdsApiConfiguration), ɵɵinject(HttpClient)); }, token: FilesService, providedIn: "root" });
if (false) {
    /** @type {?} */
    FilesService.getFilePath;
    /** @type {?} */
    FilesService.updateFilePath;
    /** @type {?} */
    FilesService.deleteFilePath;
    /** @type {?} */
    FilesService.createFilePath;
    /** @type {?} */
    FilesService.listFilesPath;
    /** @type {?} */
    FilesService.destroyFileDeprecatedPath;
    /** @type {?} */
    FilesService.archiveFilePath;
    /** @type {?} */
    FilesService.unarchiveFilePath;
}
(function (FilesService) {
    /**
     * Parameters for getFile
     * @record
     */
    function GetFileParams() { }
    FilesService.GetFileParams = GetFileParams;
    if (false) {
        /**
         * Unique identifier for the file to retrieve.
         * @type {?}
         */
        GetFileParams.prototype.fileId;
        /**
         * Optional parameter to see shared data in another tenant
         * @type {?|undefined}
         */
        GetFileParams.prototype.tenantId;
    }
    /**
     * Parameters for updateFile
     * @record
     */
    function UpdateFileParams() { }
    FilesService.UpdateFileParams = UpdateFileParams;
    if (false) {
        /**
         * Unique identifier for the file to be updated.
         * @type {?}
         */
        UpdateFileParams.prototype.fileId;
        /**
         * Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
         * @type {?|undefined}
         */
        UpdateFileParams.prototype.include;
        /** @type {?|undefined} */
        UpdateFileParams.prototype.body;
    }
    /**
     * Parameters for createFile
     * @record
     */
    function CreateFileParams() { }
    FilesService.CreateFileParams = CreateFileParams;
    if (false) {
        /** @type {?} */
        CreateFileParams.prototype.body;
        /**
         * Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
         * @type {?|undefined}
         */
        CreateFileParams.prototype.include;
    }
    /**
     * Parameters for listFiles
     * @record
     */
    function ListFilesParams() { }
    FilesService.ListFilesParams = ListFilesParams;
    if (false) {
        /**
         * Optional field that specifies comma-separated volume names to include in the list
         * @type {?|undefined}
         */
        ListFilesParams.prototype.volumeName;
        /**
         * Optional field that specifies comma-separated volume IDs to include in the list
         * @type {?|undefined}
         */
        ListFilesParams.prototype.volumeId;
        /**
         * Optional parameter to see shared data in another tenant
         * @type {?|undefined}
         */
        ListFilesParams.prototype.tenantId;
        /**
         * Optional field to specify if files should be returned recursively in and under the specified paths, or only directly in the specified paths
         * @type {?|undefined}
         */
        ListFilesParams.prototype.recursive;
        /**
         * Optional field that specifies comma-separated paths to include in the list. Value can use wildcards (e.g. /a/b/c/*) or exact matches (e.g. /a/b/c/d/).
         * @type {?|undefined}
         */
        ListFilesParams.prototype.path;
        /**
         * START_DESC END_DESC
         * @type {?|undefined}
         */
        ListFilesParams.prototype.pageToken;
        /**
         * START_DESC END_DESC
         * @type {?|undefined}
         */
        ListFilesParams.prototype.pageSize;
        /**
         * Optional field to filter by Uploaded files
         * @type {?|undefined}
         */
        ListFilesParams.prototype.isUploaded;
        /**
         * START_DESC END_DESC
         * @type {?|undefined}
         */
        ListFilesParams.prototype.include;
        /**
         * Optional field that specifies comma-separated Archive Statuses to include in the list
         * @type {?|undefined}
         */
        ListFilesParams.prototype.archiveStatus;
    }
    /**
     * Parameters for archiveFile
     * @record
     */
    function ArchiveFileParams() { }
    FilesService.ArchiveFileParams = ArchiveFileParams;
    if (false) {
        /**
         * Unique identifier for the file to be archived.
         * @type {?}
         */
        ArchiveFileParams.prototype.fileId;
        /** @type {?} */
        ArchiveFileParams.prototype.body;
    }
    /**
     * Parameters for unarchiveFile
     * @record
     */
    function UnarchiveFileParams() { }
    FilesService.UnarchiveFileParams = UnarchiveFileParams;
    if (false) {
        /**
         * Unique identifier for the file to be unarchived.
         * @type {?}
         */
        UnarchiveFileParams.prototype.fileId;
        /** @type {?} */
        UnarchiveFileParams.prototype.body;
    }
})(FilesService || (FilesService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/folders.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FoldersService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Given a volumeId or volume name, get a list of folders accessible by the JWT. The default sort returned is alphabetical, ascending. The default page size is 10 items
     * @param {?} params The `FoldersService.ListFoldersParams` containing the following parameters:
     *
     * - `volume.name`: Optional field that specifies comma-separated volume names to include in the list
     *
     * - `volume.id`: Optional field that specifies comma-separated volume IDs to include in the list
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * - `recursive`: Optional field to specify if folders should be returned recursively in and under the specified paths, or only directly in the specified paths
     *
     * - `path`: Optional field that specifies comma-separated paths to include in the list. Value can use wildcards (e.g. /a/b/c/*) or exact matches (e.g. /a/b/c/d/).
     *
     * - `pageToken`: START_DESC END_DESC
     *
     * - `pageSize`: START_DESC END_DESC
     *
     * - `jobStatuses`: Optional field that specifies comma-separated JobStatuses to include in the list
     *
     * - `include`: START_DESC END_DESC
     *
     * - `acls`: Optional field that specifies comma-separated acls to include in the list
     *
     * @return {?} Success.
     */
    listFoldersResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        (params.volumeName || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('volume.name', val.toString()); }));
        (params.volumeId || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('volume.id', val.toString()); }));
        if (params.tenantId != null)
            __params = __params.set('tenantId', params.tenantId.toString());
        if (params.recursive != null)
            __params = __params.set('recursive', params.recursive.toString());
        (params.path || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('path', val.toString()); }));
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.jobStatuses != null)
            __params = __params.set('jobStatuses', params.jobStatuses.toString());
        if (params.include != null)
            __params = __params.set('include', params.include.toString());
        (params.acls || []).forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => { if (val != null)
            __params = __params.append('acls', val.toString()); }));
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/folders`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Given a volumeId or volume name, get a list of folders accessible by the JWT. The default sort returned is alphabetical, ascending. The default page size is 10 items
     * @param {?} params The `FoldersService.ListFoldersParams` containing the following parameters:
     *
     * - `volume.name`: Optional field that specifies comma-separated volume names to include in the list
     *
     * - `volume.id`: Optional field that specifies comma-separated volume IDs to include in the list
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * - `recursive`: Optional field to specify if folders should be returned recursively in and under the specified paths, or only directly in the specified paths
     *
     * - `path`: Optional field that specifies comma-separated paths to include in the list. Value can use wildcards (e.g. /a/b/c/*) or exact matches (e.g. /a/b/c/d/).
     *
     * - `pageToken`: START_DESC END_DESC
     *
     * - `pageSize`: START_DESC END_DESC
     *
     * - `jobStatuses`: Optional field that specifies comma-separated JobStatuses to include in the list
     *
     * - `include`: START_DESC END_DESC
     *
     * - `acls`: Optional field that specifies comma-separated acls to include in the list
     *
     * @return {?} Success.
     */
    listFolders(params) {
        return this.listFoldersResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a folder entry in GDS. Returns temporary credentials for folder upload directly to S3 when the include=objectStoreAccess parameter is used. Volume ID or volume name is required for folder creation. If a folder path is provided and does not exist, GDS automatically creates the folder path in the appropriate account.
     * @param {?} params The `FoldersService.CreateFolderParams` containing the following parameters:
     *
     * - `body`:
     *
     * - `include`: Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
     *
     * @return {?} Created new Folder.
     */
    createFolderResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        if (params.include != null)
            __params = __params.set('include', params.include.toString());
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/folders`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a folder entry in GDS. Returns temporary credentials for folder upload directly to S3 when the include=objectStoreAccess parameter is used. Volume ID or volume name is required for folder creation. If a folder path is provided and does not exist, GDS automatically creates the folder path in the appropriate account.
     * @param {?} params The `FoldersService.CreateFolderParams` containing the following parameters:
     *
     * - `body`:
     *
     * - `include`: Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
     *
     * @return {?} Created new Folder.
     */
    createFolder(params) {
        return this.createFolderResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get information for the specified folder ID.
     * @param {?} params The `FoldersService.GetFolderParams` containing the following parameters:
     *
     * - `folderId`: Unique identifier for the folder to retrieve.
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * @return {?} Success.
     */
    getFolderResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.tenantId != null)
            __params = __params.set('tenantId', params.tenantId.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/folders/${params.folderId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get information for the specified folder ID.
     * @param {?} params The `FoldersService.GetFolderParams` containing the following parameters:
     *
     * - `folderId`: Unique identifier for the folder to retrieve.
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * @return {?} Success.
     */
    getFolder(params) {
        return this.getFolderResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Update an existing folder in GDS and return upload credentials for that folder. Changes to the folder name and other metadata are not supported at this time.  Optionally overwrite the acl for this folder if acl is provided in the request.
     * @param {?} params The `FoldersService.UpdateFolderParams` containing the following parameters:
     *
     * - `folderId`: Unique identifier for the folder to be updated.
     *
     * - `include`: Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
     *
     * - `body`:
     *
     * @return {?} Success.
     */
    updateFolderResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.include != null)
            __params = __params.set('include', params.include.toString());
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('PATCH', this.rootUrl + `/v1/folders/${params.folderId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Update an existing folder in GDS and return upload credentials for that folder. Changes to the folder name and other metadata are not supported at this time.  Optionally overwrite the acl for this folder if acl is provided in the request.
     * @param {?} params The `FoldersService.UpdateFolderParams` containing the following parameters:
     *
     * - `folderId`: Unique identifier for the folder to be updated.
     *
     * - `include`: Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
     *
     * - `body`:
     *
     * @return {?} Success.
     */
    updateFolder(params) {
        return this.updateFolderResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} folderId Unique identifier for the folder to be deleted.
     * @return {?} Accepted.
     */
    deleteFolderResponse(folderId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/folders/${folderId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} folderId Unique identifier for the folder to be deleted.
     * @return {?} Accepted.
     */
    deleteFolder(folderId) {
        return this.deleteFolderResponse(folderId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Archives a folder to a lower storage cost tier.
     * @param {?} params The `FoldersService.ArchiveFolderParams` containing the following parameters:
     *
     * - `folderId`: Unique identifier for the folder to be archived.
     *
     * - `body`:
     *
     * @return {?} Accepted.
     */
    archiveFolderResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/folders/${params.folderId}:archive`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Archives a folder to a lower storage cost tier.
     * @param {?} params The `FoldersService.ArchiveFolderParams` containing the following parameters:
     *
     * - `folderId`: Unique identifier for the folder to be archived.
     *
     * - `body`:
     *
     * @return {?} Accepted.
     */
    archiveFolder(params) {
        return this.archiveFolderResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Unarchive a folder from a lower storage cost tier.
     * @param {?} params The `FoldersService.UnarchiveFolderParams` containing the following parameters:
     *
     * - `folderId`: Unique identifier for the folder to be unarchived.
     *
     * - `body`:
     *
     * @return {?} Accepted.
     */
    unarchiveFolderResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/folders/${params.folderId}:unarchive`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Unarchive a folder from a lower storage cost tier.
     * @param {?} params The `FoldersService.UnarchiveFolderParams` containing the following parameters:
     *
     * - `folderId`: Unique identifier for the folder to be unarchived.
     *
     * - `body`:
     *
     * @return {?} Accepted.
     */
    unarchiveFolder(params) {
        return this.unarchiveFolderResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Get status of a folder upload in GDS.
     * @param {?} params The `FoldersService.GetFolderSessionParams` containing the following parameters:
     *
     * - `sessionId`: The id of the upload session
     *
     * - `folderId`: Unique identifier for the folder related to the upload session.
     *
     * @return {?} Completed upload session.
     */
    getFolderSessionResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/folders/${params.folderId}/sessions/${params.sessionId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get status of a folder upload in GDS.
     * @param {?} params The `FoldersService.GetFolderSessionParams` containing the following parameters:
     *
     * - `sessionId`: The id of the upload session
     *
     * - `folderId`: Unique identifier for the folder related to the upload session.
     *
     * @return {?} Completed upload session.
     */
    getFolderSession(params) {
        return this.getFolderSessionResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Complete a folder upload in GDS.
     * @param {?} params The `FoldersService.CompleteFolderSessionParams` containing the following parameters:
     *
     * - `sessionId`: The id of the upload session
     *
     * - `folderId`: Unique identifier for the folder related to the upload session.
     *
     * - `body`: The request body
     *
     * @return {?} Completed upload session. or Upload session in progress.
     */
    completeFolderSessionResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/folders/${params.folderId}/sessions/${params.sessionId}:complete`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Complete a folder upload in GDS.
     * @param {?} params The `FoldersService.CompleteFolderSessionParams` containing the following parameters:
     *
     * - `sessionId`: The id of the upload session
     *
     * - `folderId`: Unique identifier for the folder related to the upload session.
     *
     * - `body`: The request body
     *
     * @return {?} Completed upload session. or Upload session in progress.
     */
    completeFolderSession(params) {
        return this.completeFolderSessionResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
FoldersService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: FoldersService, factory: function FoldersService_Factory(t) { return new (t || FoldersService)(ɵngcc0.ɵɵinject(GdsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(FoldersService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GdsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listFoldersResponse: [], listFolders: [], createFolderResponse: [], createFolder: [], getFolderResponse: [], getFolder: [], updateFolderResponse: [], updateFolder: [], deleteFolderResponse: [], deleteFolder: [], archiveFolderResponse: [], archiveFolder: [], unarchiveFolderResponse: [], unarchiveFolder: [], getFolderSessionResponse: [], getFolderSession: [], completeFolderSessionResponse: [], completeFolderSession: [] });
FoldersService.listFoldersPath = '/v1/folders';
FoldersService.createFolderPath = '/v1/folders';
FoldersService.getFolderPath = '/v1/folders/{folderId}';
FoldersService.updateFolderPath = '/v1/folders/{folderId}';
FoldersService.deleteFolderPath = '/v1/folders/{folderId}';
FoldersService.archiveFolderPath = '/v1/folders/{folderId}:archive';
FoldersService.unarchiveFolderPath = '/v1/folders/{folderId}:unarchive';
FoldersService.getFolderSessionPath = '/v1/folders/{folderId}/sessions/{sessionId}';
FoldersService.completeFolderSessionPath = '/v1/folders/{folderId}/sessions/{sessionId}:complete';
/** @nocollapse */
FoldersService.ctorParameters = () => [
    { type: GdsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ FoldersService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FoldersService_Factory() { return new FoldersService(ɵɵinject(GdsApiConfiguration), ɵɵinject(HttpClient)); }, token: FoldersService, providedIn: "root" });
if (false) {
    /** @type {?} */
    FoldersService.listFoldersPath;
    /** @type {?} */
    FoldersService.createFolderPath;
    /** @type {?} */
    FoldersService.getFolderPath;
    /** @type {?} */
    FoldersService.updateFolderPath;
    /** @type {?} */
    FoldersService.deleteFolderPath;
    /** @type {?} */
    FoldersService.archiveFolderPath;
    /** @type {?} */
    FoldersService.unarchiveFolderPath;
    /** @type {?} */
    FoldersService.getFolderSessionPath;
    /** @type {?} */
    FoldersService.completeFolderSessionPath;
}
(function (FoldersService) {
    /**
     * Parameters for listFolders
     * @record
     */
    function ListFoldersParams() { }
    FoldersService.ListFoldersParams = ListFoldersParams;
    if (false) {
        /**
         * Optional field that specifies comma-separated volume names to include in the list
         * @type {?|undefined}
         */
        ListFoldersParams.prototype.volumeName;
        /**
         * Optional field that specifies comma-separated volume IDs to include in the list
         * @type {?|undefined}
         */
        ListFoldersParams.prototype.volumeId;
        /**
         * Optional parameter to see shared data in another tenant
         * @type {?|undefined}
         */
        ListFoldersParams.prototype.tenantId;
        /**
         * Optional field to specify if folders should be returned recursively in and under the specified paths, or only directly in the specified paths
         * @type {?|undefined}
         */
        ListFoldersParams.prototype.recursive;
        /**
         * Optional field that specifies comma-separated paths to include in the list. Value can use wildcards (e.g. /a/b/c/*) or exact matches (e.g. /a/b/c/d/).
         * @type {?|undefined}
         */
        ListFoldersParams.prototype.path;
        /**
         * START_DESC END_DESC
         * @type {?|undefined}
         */
        ListFoldersParams.prototype.pageToken;
        /**
         * START_DESC END_DESC
         * @type {?|undefined}
         */
        ListFoldersParams.prototype.pageSize;
        /**
         * Optional field that specifies comma-separated JobStatuses to include in the list
         * @type {?|undefined}
         */
        ListFoldersParams.prototype.jobStatuses;
        /**
         * START_DESC END_DESC
         * @type {?|undefined}
         */
        ListFoldersParams.prototype.include;
        /**
         * Optional field that specifies comma-separated acls to include in the list
         * @type {?|undefined}
         */
        ListFoldersParams.prototype.acls;
    }
    /**
     * Parameters for createFolder
     * @record
     */
    function CreateFolderParams() { }
    FoldersService.CreateFolderParams = CreateFolderParams;
    if (false) {
        /** @type {?} */
        CreateFolderParams.prototype.body;
        /**
         * Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
         * @type {?|undefined}
         */
        CreateFolderParams.prototype.include;
    }
    /**
     * Parameters for getFolder
     * @record
     */
    function GetFolderParams() { }
    FoldersService.GetFolderParams = GetFolderParams;
    if (false) {
        /**
         * Unique identifier for the folder to retrieve.
         * @type {?}
         */
        GetFolderParams.prototype.folderId;
        /**
         * Optional parameter to see shared data in another tenant
         * @type {?|undefined}
         */
        GetFolderParams.prototype.tenantId;
    }
    /**
     * Parameters for updateFolder
     * @record
     */
    function UpdateFolderParams() { }
    FoldersService.UpdateFolderParams = UpdateFolderParams;
    if (false) {
        /**
         * Unique identifier for the folder to be updated.
         * @type {?}
         */
        UpdateFolderParams.prototype.folderId;
        /**
         * Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
         * @type {?|undefined}
         */
        UpdateFolderParams.prototype.include;
        /** @type {?|undefined} */
        UpdateFolderParams.prototype.body;
    }
    /**
     * Parameters for archiveFolder
     * @record
     */
    function ArchiveFolderParams() { }
    FoldersService.ArchiveFolderParams = ArchiveFolderParams;
    if (false) {
        /**
         * Unique identifier for the folder to be archived.
         * @type {?}
         */
        ArchiveFolderParams.prototype.folderId;
        /** @type {?} */
        ArchiveFolderParams.prototype.body;
    }
    /**
     * Parameters for unarchiveFolder
     * @record
     */
    function UnarchiveFolderParams() { }
    FoldersService.UnarchiveFolderParams = UnarchiveFolderParams;
    if (false) {
        /**
         * Unique identifier for the folder to be unarchived.
         * @type {?}
         */
        UnarchiveFolderParams.prototype.folderId;
        /** @type {?} */
        UnarchiveFolderParams.prototype.body;
    }
    /**
     * Parameters for getFolderSession
     * @record
     */
    function GetFolderSessionParams() { }
    FoldersService.GetFolderSessionParams = GetFolderSessionParams;
    if (false) {
        /**
         * The id of the upload session
         * @type {?}
         */
        GetFolderSessionParams.prototype.sessionId;
        /**
         * Unique identifier for the folder related to the upload session.
         * @type {?}
         */
        GetFolderSessionParams.prototype.folderId;
    }
    /**
     * Parameters for completeFolderSession
     * @record
     */
    function CompleteFolderSessionParams() { }
    FoldersService.CompleteFolderSessionParams = CompleteFolderSessionParams;
    if (false) {
        /**
         * The id of the upload session
         * @type {?}
         */
        CompleteFolderSessionParams.prototype.sessionId;
        /**
         * Unique identifier for the folder related to the upload session.
         * @type {?}
         */
        CompleteFolderSessionParams.prototype.folderId;
        /**
         * The request body
         * @type {?}
         */
        CompleteFolderSessionParams.prototype.body;
    }
})(FoldersService || (FoldersService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services/volumes.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VolumesService extends BaseService {
    /**
     * @param {?} config
     * @param {?} http
     */
    constructor(config, http) {
        super(config, http);
    }
    /**
     * Get a list of volumes accessible by the current JWT token’s tenant ID in GDS. The default sort returned is alphabetical, ascending. The default page size is 10 items.
     * @param {?} params The `VolumesService.ListVolumesParams` containing the following parameters:
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * - `pageToken`: START_DESC END_DESC
     *
     * - `pageSize`: START_DESC END_DESC
     *
     * - `include`: START_DESC END_DESC
     *
     * @return {?} Success.
     */
    listVolumesResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.tenantId != null)
            __params = __params.set('tenantId', params.tenantId.toString());
        if (params.pageToken != null)
            __params = __params.set('pageToken', params.pageToken.toString());
        if (params.pageSize != null)
            __params = __params.set('pageSize', params.pageSize.toString());
        if (params.include != null)
            __params = __params.set('include', params.include.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/volumes`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Get a list of volumes accessible by the current JWT token’s tenant ID in GDS. The default sort returned is alphabetical, ascending. The default page size is 10 items.
     * @param {?} params The `VolumesService.ListVolumesParams` containing the following parameters:
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * - `pageToken`: START_DESC END_DESC
     *
     * - `pageSize`: START_DESC END_DESC
     *
     * - `include`: START_DESC END_DESC
     *
     * @return {?} Success.
     */
    listVolumes(params) {
        return this.listVolumesResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * Create a volume in GDS to hold folders and files. Returns upload credentials to the root folder of the volume when the include=objectStoreAccess parameter is used. You must create a volume prior to uploading files or folders.
     * @param {?} params The `VolumesService.CreateVolumeParams` containing the following parameters:
     *
     * - `body`:
     *
     * - `include`: Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
     *
     * @return {?} Created new Volume.
     */
    createVolumeResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        __body = params.body;
        if (params.include != null)
            __params = __params.set('include', params.include.toString());
        /** @type {?} */
        let req = new HttpRequest('POST', this.rootUrl + `/v1/volumes`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * Create a volume in GDS to hold folders and files. Returns upload credentials to the root folder of the volume when the include=objectStoreAccess parameter is used. You must create a volume prior to uploading files or folders.
     * @param {?} params The `VolumesService.CreateVolumeParams` containing the following parameters:
     *
     * - `body`:
     *
     * - `include`: Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
     *
     * @return {?} Created new Volume.
     */
    createVolume(params) {
        return this.createVolumeResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} params The `VolumesService.GetVolumeParams` containing the following parameters:
     *
     * - `volumeId`: Unique identifier for the volume to retrieve information for.
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * @return {?} Success.
     */
    getVolumeResponse(params) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        if (params.tenantId != null)
            __params = __params.set('tenantId', params.tenantId.toString());
        /** @type {?} */
        let req = new HttpRequest('GET', this.rootUrl + `/v1/volumes/${params.volumeId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} params The `VolumesService.GetVolumeParams` containing the following parameters:
     *
     * - `volumeId`: Unique identifier for the volume to retrieve information for.
     *
     * - `tenantId`: Optional parameter to see shared data in another tenant
     *
     * @return {?} Success.
     */
    getVolume(params) {
        return this.getVolumeResponse(params).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
    /**
     * @param {?} volumeId Unique identifier for the Volume to be deleted.
     * @return {?} Accepted.
     */
    deleteVolumeResponse(volumeId) {
        /** @type {?} */
        let __params = this.newParams();
        /** @type {?} */
        let __headers = new HttpHeaders();
        /** @type {?} */
        let __body = null;
        /** @type {?} */
        let req = new HttpRequest('DELETE', this.rootUrl + `/v1/volumes/${volumeId}`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(filter((/**
         * @param {?} _r
         * @return {?}
         */
        _r => _r instanceof HttpResponse)), map((/**
         * @param {?} _r
         * @return {?}
         */
        (_r) => {
            return (/** @type {?} */ (_r));
        })));
    }
    /**
     * @param {?} volumeId Unique identifier for the Volume to be deleted.
     * @return {?} Accepted.
     */
    deleteVolume(volumeId) {
        return this.deleteVolumeResponse(volumeId).pipe(map((/**
         * @param {?} _r
         * @return {?}
         */
        _r => (/** @type {?} */ (_r.body)))));
    }
}
VolumesService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: VolumesService, factory: function VolumesService_Factory(t) { return new (t || VolumesService)(ɵngcc0.ɵɵinject(GdsApiConfiguration), ɵngcc0.ɵɵinject(HttpClient)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(VolumesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GdsApiConfiguration }, { type: HttpClient }]; }, { constructor: [], listVolumesResponse: [], listVolumes: [], createVolumeResponse: [], createVolume: [], getVolumeResponse: [], getVolume: [], deleteVolumeResponse: [], deleteVolume: [] });
VolumesService.listVolumesPath = '/v1/volumes';
VolumesService.createVolumePath = '/v1/volumes';
VolumesService.getVolumePath = '/v1/volumes/{volumeId}';
VolumesService.deleteVolumePath = '/v1/volumes/{volumeId}';
/** @nocollapse */
VolumesService.ctorParameters = () => [
    { type: GdsApiConfiguration },
    { type: HttpClient }
];
/** @nocollapse */ VolumesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function VolumesService_Factory() { return new VolumesService(ɵɵinject(GdsApiConfiguration), ɵɵinject(HttpClient)); }, token: VolumesService, providedIn: "root" });
if (false) {
    /** @type {?} */
    VolumesService.listVolumesPath;
    /** @type {?} */
    VolumesService.createVolumePath;
    /** @type {?} */
    VolumesService.getVolumePath;
    /** @type {?} */
    VolumesService.deleteVolumePath;
}
(function (VolumesService) {
    /**
     * Parameters for listVolumes
     * @record
     */
    function ListVolumesParams() { }
    VolumesService.ListVolumesParams = ListVolumesParams;
    if (false) {
        /**
         * Optional parameter to see shared data in another tenant
         * @type {?|undefined}
         */
        ListVolumesParams.prototype.tenantId;
        /**
         * START_DESC END_DESC
         * @type {?|undefined}
         */
        ListVolumesParams.prototype.pageToken;
        /**
         * START_DESC END_DESC
         * @type {?|undefined}
         */
        ListVolumesParams.prototype.pageSize;
        /**
         * START_DESC END_DESC
         * @type {?|undefined}
         */
        ListVolumesParams.prototype.include;
    }
    /**
     * Parameters for createVolume
     * @record
     */
    function CreateVolumeParams() { }
    VolumesService.CreateVolumeParams = CreateVolumeParams;
    if (false) {
        /** @type {?} */
        CreateVolumeParams.prototype.body;
        /**
         * Comma-separated list of properties to include in the response ([include=[totalItemCount]).Example: include=totalItemCount
         * @type {?|undefined}
         */
        CreateVolumeParams.prototype.include;
    }
    /**
     * Parameters for getVolume
     * @record
     */
    function GetVolumeParams() { }
    VolumesService.GetVolumeParams = GetVolumeParams;
    if (false) {
        /**
         * Unique identifier for the volume to retrieve information for.
         * @type {?}
         */
        GetVolumeParams.prototype.volumeId;
        /**
         * Optional parameter to see shared data in another tenant
         * @type {?|undefined}
         */
        GetVolumeParams.prototype.tenantId;
    }
})(VolumesService || (VolumesService = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: api/services.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: api/gds-api.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Provider for all GdsApi services, plus GdsApiConfiguration
 */
class GdsApiModule {
    /**
     * @param {?} customParams
     * @return {?}
     */
    static forRoot(customParams) {
        return {
            ngModule: GdsApiModule,
            providers: [
                {
                    provide: GdsApiConfiguration,
                    useValue: { rootUrl: customParams.rootUrl }
                }
            ]
        };
    }
}
GdsApiModule.ngModuleDef = ɵngcc0.ɵɵdefineNgModule({ type: GdsApiModule });
/*@__PURE__*/ ɵngcc0.ɵɵsetNgModuleScope(GdsApiModule, { imports: function () { return [HttpClientModule]; }, exports: function () { return [HttpClientModule]; } });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(GdsApiModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule
                ],
                exports: [
                    HttpClientModule
                ],
                declarations: [],
                providers: [
                    GdsApiConfiguration,
                    FilesService,
                    FoldersService,
                    VolumesService
                ]
            }]
    }], null, null);
GdsApiModule.ngInjectorDef = ɵngcc0.ɵɵdefineInjector({ factory: function GdsApiModule_Factory(t) { return new (t || GdsApiModule)(); }, providers: [
        GdsApiConfiguration,
        FilesService,
        FoldersService,
        VolumesService
    ], imports: [[
            HttpClientModule
        ],
        HttpClientModule] });

/**
 * @fileoverview added by tsickle
 * Generated from: projects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: stratus-gds-ng-sdk.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ArchiveStatuses, BaseService, FileArchiveStorageTier, FilesService, FolderArchiveStorageTier, FoldersService, GdsApiModule, JobStatus, SessionStatus, StorageTier, VolumesService, GdsApiConfiguration as ɵa };

//# sourceMappingURL=stratus-gds-ng-sdk.js.map